const tableColumns = {
	teams: {
		lead: { index: 'lead', title: 'Lead Manager', group: '-' },

		desired_real_approves_count: { index: 'desired_real_approves_count', title: 'План', group: 'Апрувы' },
		real_approve_count: { index: 'real_approve_count', title: 'Факт', group: 'Апрувы' },
		real_approve_fulfilment: { index: 'real_approve_fulfilment', title: '%% Выполн', group: 'Апрувы' },
		real_approve_fulfilment_forecast: {
			index: 'real_approve_fulfilment_forecast', title: '%% Прогноз', group: 'Апрувы'
		},

		desired_profit_usd: { index: 'desired_profit_usd', title: 'План', group: 'Маржа' },
		profit_usd: { index: 'profit_usd', title: 'Факт', group: 'Маржа' },
		profit_fulfilment: { index: 'profit_fulfilment', title: '%% Выполн', group: 'Маржа' },
		profit_fulfilment_forecast: {
			index: 'profit_fulfilment_forecast', title: '%% Прогноз', group: 'Маржа'
		},

		affiliates_plan: { index: 'affiliates_plan', title: 'План', group: 'Активные вебы' },
		active_affiliates_count: { index: 'active_affiliates_count', title: 'К-во', group: 'Активные вебы' },
		active_affiliates_fulfilment: {
			index: 'active_affiliates_fulfilment', title: '%% Выполн', group: 'Активные вебы'
		},
		active_affiliates_fulfilment_forecast: {
			index: 'active_affiliates_fulfilment_forecast', title: '%% Прогноз', group: 'Активные вебы'
		}
	},
	individual: {
		manager: { index: 'manager', title: 'Manager', group: '-' },

		desired_real_approves_count: { index: 'desired_real_approves_count', title: 'План', group: 'Апрувы' },
		real_approve_count: { index: 'real_approve_count', title: 'Факт', group: 'Апрувы' },
		real_approve_fulfilment: { index: 'real_approve_fulfilment', title: '%% Выполн', group: 'Апрувы' },
		real_approve_fulfilment_forecast: {
			index: 'real_approve_fulfilment_forecast', title: '%% Прогноз', group: 'Апрувы'
		},

		desired_profit_usd: { index: 'desired_profit_usd', title: 'План', group: 'Маржа' },
		profit_usd: { index: 'profit_usd', title: 'Факт', group: 'Маржа' },
		profit_fulfilment: { index: 'profit_fulfilment', title: '%% Выполн', group: 'Маржа' },
		profit_fulfilment_forecast: {
			index: 'profit_fulfilment_forecast', title: '%% Прогноз', group: 'Маржа'
		},

		affiliates_plan: { index: 'affiliates_plan', title: 'План', group: 'Активные вебы' },
		active_affiliates_count: { index: 'active_affiliates_count', title: 'К-во', group: 'Активные вебы' },
		active_affiliates_fulfilment: {
			index: 'active_affiliates_fulfilment', title: '%% Выполн', group: 'Активные вебы'
		},
		active_affiliates_fulfilment_forecast: {
			index: 'active_affiliates_fulfilment_forecast', title: '%% Прогноз', group: 'Активные вебы'
		}
	},
	motivation: {
		lead_manager: { index: 'lead_manager', title: 'Lead manager' },
		income_fulfilment_percent: { index: 'approval_percent', title: '%% Выполн ( на дату отчета)' }
	}
};

function getTableColumns(name) {
	return tableColumns[name] || tableColumns['teams'];
}

export default getTableColumns;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliate-managers-productivity/components/table/getColumns.js